import React from 'react';
import { useState } from 'react';
import { Practicaja } from './registros/Practicaja';
import { Ventanilla } from './registros/Ventanilla';

export const Registro = () => {

    const [tipo, setTipo] = useState(1);

    return (
        <div>
            <div className="fc-toolbar fc-header-toolbar mb-4">
                <div className="col-12 text-center">
                    <div className="btn-group">
                        <button 
                            type="button" 
                            onClick={() => setTipo(1)}
                            className={`fc-dayGridMonth-button btn btn-primary ${tipo === 1 && 'active'}`}
                        >
                            Practicaja
                        </button>
                        <button 
                            type="button" 
                            onClick={() => setTipo(2)} 
                            className={`fc-dayGridMonth-button btn btn-primary ${tipo === 2 && 'active'}`}
                        >
                            Ventanilla
                        </button>
                    </div>
                </div>
            </div>
            <h6 className="text-warning">Registra tu pago uno o dos días hábiles después de realizarlo, ya que es lo que tarda en verse reflejado en el sistema.</h6>


            {
                tipo === 1 
                    ? <Practicaja />
                    : <Ventanilla />
            }
        </div>
    )
}
